// Tribunais que publicam no DJEN, agrupados para a escolha no perfil.
import { N_ } from '../../lib/i18n';

const UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
const seq = (pre: string, n: number) => Array.from({ length: n }, (_, i) => `${pre}${i + 1}`);

export const GRUPOS_TRIBUNAIS: { nome: string; siglas: string[] }[] = [
  { nome: N_('Superiores'), siglas: ['STF', 'STJ', 'TST', 'TSE', 'STM'] },
  { nome: N_('Federais'), siglas: seq('TRF', 6) },
  { nome: N_('Trabalho'), siglas: seq('TRT', 24) },
  { nome: N_('Estaduais'), siglas: UFS.map(u => `TJ${u === 'DF' ? 'DFT' : u}`) },
  { nome: N_('Militares estaduais'), siglas: ['TJMMG', 'TJMRS', 'TJMSP'] },
  { nome: N_('Eleitorais'), siglas: UFS.map(u => `TRE-${u}`) },
];

/** Compara siglas sem hífen, espaço e maiúsculas ("TRE-MS" = "TREMS"; "TJDF" = "TJDFT"). */
export const normSigla = (s: string) => {
  const x = s.toUpperCase().replace(/[^A-Z0-9]/g, '');
  return x === 'TJDF' ? 'TJDFT' : x;
};

/** true se a publicação do tribunal `sigla` deve entrar para a seleção `tribunais` (vazia = todos). */
export function tribunalAceito(sigla: string, tribunais?: string[]) {
  if (!tribunais?.length) return true;
  const s = normSigla(sigla);
  return tribunais.some(t => normSigla(t) === s);
}
